/* eslint-disable no-nested-ternary */
import { Box, Stack } from '@mui/material';
import { modalModel } from 'entities/modal';
import { Icons } from 'shared';

import { splitButtonsList } from './utils/splitButtonsList';
import { buttonsList } from './constants';
import { CratCircleProps, OpenModalActionType } from './crat-circle.types';
import { CircleItem } from './item';
import { Logo } from './logo';

const splittedButtonsList = splitButtonsList(buttonsList);

const renderButtonsList = (
  list: typeof buttonsList,
  clickHandler: (type: OpenModalActionType) => void,
  isTop?: boolean,
) => {
  const coords = isTop
    ? {
        top: 72,
        left: 48,
      }
    : {
        bottom: 48,
        left: 36,
      };

  return list.map((btn) => (
    <Box
      key={btn.modal}
      sx={{
        position: 'relative',
      }}
    >
      <CircleItem onClick={() => clickHandler(btn.modal)} title={btn.title} Icon={btn.Icon} />
      {btn?.line && (
        <Box
          sx={{
            position: 'absolute',
            zIndex: -1,
            ...coords,
          }}
        >
          {btn.line}
        </Box>
      )}
    </Box>
  ));
};

export const CratCircleMobile = ({ sx, onButtonClick }: CratCircleProps) => {
  return (
    <Stack
      gap={4}
      display="flex"
      flexDirection="column"
      width={320}
      sx={{ marginLeft: 'auto', marginRight: 'auto', ...sx }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridTemplateRows: 'repeat(2, 128.5px)',
          alignItems: 'flex-start',
          gridGap: 16,
        }}
      >
        {renderButtonsList(splittedButtonsList.topHalf as unknown as typeof buttonsList, onButtonClick, true)}
      </Box>
      <Box alignSelf="center" position="relative">
        <Logo onClick={() => onButtonClick(modalModel.ModalType.CratNew)} />
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Icons.MiddleLine />
        </Box>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridGap: 16,
          alignItems: 'flex-start',
        }}
      >
        {renderButtonsList(splittedButtonsList.bottomHalf as unknown as typeof buttonsList, onButtonClick)}
      </Box>
    </Stack>
  );
};
